import { ReactNode } from 'react'
import { CustomTitle } from 'src/components'

import { TFunction } from 'next-i18next'
import FilterUserByStatus from './FilterUserByStatus/FilterUserByStatus'
import FilterUserByType from './FilterUserByType/FilterUserByType'
import FilterUserInput from './FilterUserInput/FilterUserInput'
import FilterUsersByGroup from './FilterUsersByGroup/FilterUsersByGroup'
import ResetUserListFilter from './ResetUserListFilter/ResetUserListFilter'

export const filterSections = (
  t: TFunction, usersLength: number
): { lg: number, children: ReactNode }[] => [

  { // Header Title
    lg: 6,
    children: <CustomTitle label={`${t('general.ResultsLength', { length: usersLength })}`} type={null} />
  },
  { // Group Filter
    lg: 4,
    children: <FilterUsersByGroup />
  },
  { // Status Filter
    lg: 3,
    children: <FilterUserByStatus />
  },
  { // Type Filter
    lg: 3,
    children: <FilterUserByType />
  },
  { // Input Filter
    lg: 5,
    children: <FilterUserInput />
  },
  { // Reset Button
    lg: 3,
    children: <ResetUserListFilter />
  },
]
